import { action } from 'satcheljs';
import { addCoreDatapointConfig } from 'owa-analytics-actions';
import getAllDayWellHeight from '../selectors/getAllDayWellHeight';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * Called to update the height of the collapsed all day well
 */

export interface UpdateCollapsedAllDayWellHeightActionMessage {
    newValue: number;
}
export const updateCollapsedAllDayWellHeight: (
    newValue: number
) => UpdateCollapsedAllDayWellHeightActionMessage = action(
    'updateCollapsedAllDayWellHeight',
    (newValue: number): UpdateCollapsedAllDayWellHeightActionMessage => {
        const userAllDayWellHeight = getAllDayWellHeight();

        if (userAllDayWellHeight === newValue) {
            return { newValue };
        }
        const expanding = userAllDayWellHeight < newValue;

        return addCoreDatapointConfig(
            'UpdateCollapsedAllDayWellHeight',
            getModuleContextMailboxInfo(),
            {
                customData: {
                    expanded: expanding,
                },
            },
            {
                newValue,
            }
        );
    }
);
